import React from 'react';
import { CircularProgress } from '@material-ui/core';

import './style.scss';

export default function Loading() {
  return (
    <section className='loading-container'>
      <div className='loading-logo'>
        <img src={require('./../../img/logo-patagonia-blanco.svg')} alt='' />
      </div>
      <div className='loading-modal'>
        <div className='loading-text-container'>
          <p>
            <b>¡Esperanos!</b> Estamos procesando tu solicitud
          </p>
        </div>
        <hr />
        <CircularProgress disableShrink />
      </div>
    </section>
  );
}
